import { LOCAL_STORAGE_ACCESS_TOKEN } from '@/helpers/local_storage_constants';
const baseURL = `${process.env.VUE_APP_API_BASE_REST_TELEMETRIC_API_INFOHIDRO}`;
const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN);
const END_POINT = '/hydrologicalhourlysummary_zip';

const loadHydrologicalHourlySummary = async (payload) => {

  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  // Referência para leitura Stream/Chuncked https://developer.mozilla.org/en-US/docs/Web/API/Streams_API/Using_readable_streams#reading_the_stream
  const response = await fetch((`${baseURL}${END_POINT}`), options)
    .then((response) => {
      const reader = response.body.getReader();
      return new ReadableStream({
        start(controller) {
          return pump();
          function pump() {
            return reader.read().then(({ done, value }) => {
              // When no more data needs to be consumed, close the stream
              if (done) {
                controller.close();
                return;
              }
              // Enqueue the next data chunk into our target stream
              controller.enqueue(value);
              return pump();
            });
          }
        },
      });
    })
    // Create a new response out of the stream
    .then((stream) => new Response(stream))
    // Create an object URL for the response
    .then((response) => response.blob())
    .then((blob) => URL.createObjectURL(blob))
    // Update image
    .then((url) => {
      const link = document.createElement('a');
      link.download = `serie_completa_sumario_horario_${payload.stationId}.zip`;
      link.href = url;
      link.click();
    })
    .catch((err) => console.error(err));
  return response;
}

export {
  loadHydrologicalHourlySummary,
}
